import React from 'react';

interface ServiceCardProps {
    title: string;
    description: string;
    image: string;
    icon?: string;
    tags?: string[];
    onClick?: () => void;
    className?: string;
}

export default function ServiceCard({
    title,
    description,
    image,
    icon,
    tags = [],
    onClick,
    className = ''
}: ServiceCardProps) {
    return (
        <div
            className={`bg-white dark:bg-slate-800 rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer group ${className}`}
            onClick={onClick}
        >
            <div className="relative h-64 w-full overflow-hidden">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white dark:bg-slate-700 rounded-full shadow-lg">
                    <i className={`${icon || 'ri-service-line'} text-2xl text-[#e18033]`}></i>
                </div>
            </div>

            <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3 group-hover:text-[#e18033] transition-colors">
                    {title}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 leading-relaxed line-clamp-3">
                    {description}
                </p>

                {tags && tags.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-4">
                        {tags.slice(0, 3).map((tag, index) => (
                            <span
                                key={index}
                                className="text-xs bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded-full"
                            >
                                {tag}
                            </span>
                        ))}
                        {tags.length > 3 && (
                            <span className="text-xs bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300 px-3 py-1 rounded-full">
                                +{tags.length - 3}
                            </span>
                        )}
                    </div>
                )}

            </div>
        </div>
    );
}
